// SPDX-License-Identifier: LicenseRef-Proprietary

import React from 'react';
import { ValidationIssue, getValidationStatus } from '../../lib/validation';

interface ValidationBadgeProps {
  issues: ValidationIssue[];
  onClick?: () => void;
}

const ValidationBadge: React.FC<ValidationBadgeProps> = ({ issues, onClick }) => {
  const status = getValidationStatus(issues);
  const hasIssues = status.hasIssues;

  return (
    <span
      className={`status-badge ${status.className}`}
      onClick={hasIssues ? onClick : undefined}
      style={{ 
        cursor: hasIssues ? 'pointer' : 'default',
        userSelect: 'none'
      }}
      title={hasIssues ? 'Click to view details' : 'No validation issues'}
      role="status"
      aria-live="polite"
      aria-label={`Validation status: ${status.text}`}
    >
      {status.text}
    </span>
  );
};

export default ValidationBadge;
